import { Pipe, PipeTransform } from '@angular/core';
import { InvestisseurType } from '@lib/models/generated/graphql';

@Pipe({
  name: 'investisseurType',
})
export class InvestisseurTypePipe implements PipeTransform {
  transform(typeInv: InvestisseurType | undefined): string {
    return typeInv === InvestisseurType.PersonneMorale ? 'Personne morale' : 'Personne physique';
  }
}
